import { render, staticRenderFns } from "./UploadProject.vue?vue&type=template&id=216acf6b&"
import script from "./UploadProject.vue?vue&type=script&lang=js&"
export * from "./UploadProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!/////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports